import React, { useEffect, useState } from "react";

import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  Nav,
  NavItem,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  NavLink,
  UncontrolledTooltip,
} from "reactstrap";
import { createSelector } from "reselect";
// hooks
import { useRedux } from "../../hooks/index";

// actions
import { changeTab, changeSelectedChat, ucLoadUserConfig, setActiveTool } from "../../redux/actions";
import { setActivePostId2 } from "../../redux/workplace/wpActions";

// costants
import { TABS, WpModes } from "../../constants/index";
import LightDarkMode from "../../components/LightDarkMode";

//images
import avatar1 from "../../assets/images/users/avatar-1.jpg";

// menu
import { MENU_ITEMS, MenuItemType } from "./menu";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";

import { selectTotalUnreadCount, selectTotalUnreadCountSup } from "../../redux/selector";
import UserAvatar from "components/UserAvatar";
import { UserTypes } from "api";
import { WpSliceData } from "../../redux/workplace/wpTypes";
import { ThirdApi } from "api/apiThird";
import { Const, SKeys } from "const";

const LogoLightSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
    >
      <path d="M8.5,18l3.5,4l3.5-4H19c1.103,0,2-0.897,2-2V4c0-1.103-0.897-2-2-2H5C3.897,2,3,2.897,3,4v12c0,1.103,0.897,2,2,2H8.5z M7,7h10v2H7V7z M7,11h7v2H7V11z" />
    </svg>
  );
};

const LogoDarkSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
    >
      <path d="M8.5,18l3.5,4l3.5-4H19c1.103,0,2-0.897,2-2V4c0-1.103-0.897-2-2-2H5C3.897,2,3,2.897,3,4v12c0,1.103,0.897,2,2,2H8.5z M7,7h10v2H7V7z M7,11h7v2H7V11z" />
    </svg>
  );
};

const Logo2s = () => {
  return (
    <img src="https://www.2smetal.com/uploads/DConnect/Logo/logo-dconnect.webp" width={40}></img>
  );
};
const Logo = () => {
  return (
    <div className="navbar-brand-box">
      <Link to="#" className="logo logo-dark">
        <span className="logo-sm">
          {/* <LogoLightSVG /> */}
          <Logo2s />
        </span>
      </Link>

      <Link to="#" className="logo logo-light">
        <span className="logo-sm">
          {/* <LogoDarkSVG /> */}
          <Logo2s />
        </span>
      </Link>
    </div>
  );
};

interface MenuNavItemProps {
  item: MenuItemType;
  selectedTab:
  | TABS.BOOKMARK
  | TABS.CALLS
  | TABS.CHAT
  | TABS.CHAT_SUP
  | TABS.CONTACTS
  | TABS.SETTINGS
  | TABS.USERS
  | TABS.TEST
  | TABS.WORKPLACE
  | TABS.TASK
  | TABS.APPROVAL
  ;
  onChangeTab: (
    id:
      | TABS.BOOKMARK
      | TABS.CALLS
      | TABS.CHAT
      | TABS.CHAT_SUP
      | TABS.CONTACTS
      | TABS.SETTINGS
      | TABS.USERS
      | TABS.TEST
      | TABS.WORKPLACE
      | TABS.TASK
      | TABS.APPROVAL

  ) => void;
}
const MenuNavItem = ({ item, selectedTab, onChangeTab }: MenuNavItemProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const totalUnreadCount = useAppSelector(selectTotalUnreadCount);
  const totalUnreadCountSup = useAppSelector(selectTotalUnreadCountSup);
  const storeData = createSelector(
    (state) => state.ChatContacts2,
    (state: any) => state.Layout,
    (state) => state.WpSlice,
    (state: any) => state.Settings,
    (state, layout, wp: WpSliceData, settings) => ({
      isContactLoading: state.loading,
      isGrantNotification: layout.isGrantNotification,
      activeTab: layout.activeTab,
      wpRoleUnread: wp.roleUnread,
      approvalPendingCount: layout.approvalPendingCount,
      hasOptionalAppUpdate: settings.appUpdateInfo?.isuptodate === false,
    })
  );
  const { isContactLoading, isGrantNotification, wpRoleUnread, activeTab, approvalPendingCount, hasOptionalAppUpdate } = useAppSelector(storeData);
  // console.log('wpRoleUnread:', wpRoleUnread);
  const totalWpUnread = wpRoleUnread.unreadFlag + wpRoleUnread.unreadFollower + wpRoleUnread.unreadMyPost + wpRoleUnread.unreadOwner + wpRoleUnread.unreadTagMe + wpRoleUnread.unreadOrganize + wpRoleUnread.unreadPersonFollow + wpRoleUnread.unreadObserver;
  const totalTaskUnread = wpRoleUnread.taskUnreadMine + wpRoleUnread.taskUnreadAssigner + wpRoleUnread.taskUnreadRequestBy + wpRoleUnread.taskUnreadFlag + wpRoleUnread.taskUnreadRelated + wpRoleUnread.taskUnreadObserver;

  // console.log('totalUnreadCount:', totalUnreadCount);
  // console.log('MenuItem:', item);
  const onClick = () => {
    onChangeTab(item.tabId);
  };

  useEffect(() => {
    // console.log('Total unread count changed:', totalUnreadCount);
    const total =
      Number(totalUnreadCount ?? 0) +
      Number(totalWpUnread ?? 0) +
      Number(totalTaskUnread ?? 0) + // Task was missing, so reading a task never moved the icon
      Number(totalUnreadCountSup ?? 0) +
      Number(approvalPendingCount ?? 0); // same 5 parts as the server push badge, PG fn_getappbadgecount (sql-log Step 15)

    if (Number.isFinite(total) && total >= 0) {
      Utils.SetAppBadge(Math.floor(total), `app c${totalUnreadCount ?? 0}+w${totalWpUnread ?? 0}+t${totalTaskUnread ?? 0}+s${totalUnreadCountSup ?? 0}+a${approvalPendingCount ?? 0}`);
    }
  }, [totalUnreadCount, totalWpUnread, totalTaskUnread, isContactLoading, totalUnreadCountSup, approvalPendingCount]);

  useEffect(() => {
    //if (activeTab == TABS.CHAT) {
    if (activeTab == TABS.CHAT || activeTab == TABS.CHAT_SUP) {
      if (totalUnreadCount > 0) {
        document.title = process.env.REACT_APP_NAME + ` (${totalUnreadCount + totalUnreadCountSup})`;
      } else {
        document.title = (process.env.REACT_APP_NAME ?? "Chat");
      }
    }
  }, [totalUnreadCount, activeTab, totalUnreadCountSup]);

  useEffect(() => {
    if (activeTab == TABS.WORKPLACE) {
      if (totalWpUnread > 0) {
        document.title = `Workplace ${process.env.REACT_APP_COMPANY_ABBR} (${totalWpUnread})`;
      } else {
        document.title = `Workplace ${process.env.REACT_APP_COMPANY_ABBR}`;
      }
    } else if (activeTab == TABS.TASK) {
      if (totalTaskUnread > 0) {
        document.title = `Task ${process.env.REACT_APP_COMPANY_ABBR} (${totalTaskUnread})`;
      } else {
        document.title = `Task ${process.env.REACT_APP_COMPANY_ABBR}`;
      }

    }
  }, [totalWpUnread, totalTaskUnread, activeTab]);


  return (
    <>
      <NavItem className={item.className} id={`${item.key}-container`}>
        <NavLink
          href="#"
          active={selectedTab === item.tabId}
          id={item.key}
          role="tab"
          onClick={onClick}
        >
          <i className={item.icon}></i>
          {item.tabId == TABS.CHAT && totalUnreadCount > 0 && (
            <span className="badge-menuitem">{totalUnreadCount}</span>
          )}
          {item.tabId == TABS.CHAT_SUP && totalUnreadCountSup > 0 && (
            <span className="badge-menuitem">{totalUnreadCountSup}</span>
          )}
          {item.tabId == TABS.WORKPLACE && totalWpUnread > 0 && (
            <span className="badge-menuitem">{totalWpUnread}</span>
          )}
          {item.tabId == TABS.TASK && totalTaskUnread > 0 && (
            <span className="badge-menuitem">{totalTaskUnread}</span>
          )}
          {item.tabId == TABS.APPROVAL && approvalPendingCount > 0 && (
            <span className="badge-menuitem">{approvalPendingCount}</span>
          )}
          {item.tabId == TABS.SETTINGS && hasOptionalAppUpdate && (
            <span className="badge-menuitem" title="มีอัปเดตใหม่"><span className="mdi mdi-update"></span></span>
          )}
          {item.tabId == TABS.SETTINGS && !hasOptionalAppUpdate && !isGrantNotification && (
            <span className="badge-menuitem"><span className="mdi mdi-bell-off-outline"></span></span>
          )}

        </NavLink>
      </NavItem>
      {/* <UncontrolledTooltip target={`${item.key}-container`} placement="right"  >
        {item.tooltipTitle}
      </UncontrolledTooltip> */}
    </>
  );
};

interface ProfileDropdownMenuProps {
  onChangeTab: (
    id:
      | TABS.BOOKMARK
      | TABS.CALLS
      | TABS.CHAT
      | TABS.CHAT_SUP
      | TABS.CONTACTS
      | TABS.SETTINGS
      | TABS.USERS
      | TABS.TEST
      | TABS.WORKPLACE
      | TABS.TASK
      | TABS.APPROVAL

  ) => void;
}
const ProfileDropdownMenu = ({ onChangeTab }: ProfileDropdownMenuProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const { dispatch, useAppSelector } = useRedux();
  const navigate = useNavigate();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state) => ({
      profile2: state,
      webUserId: state.webUserId,
      customerIsCdSys: state.customerIsCdSys,
    })
  );
  const { profile2, webUserId, customerIsCdSys } = useAppSelector(storeData);

  const showIncompletedMenu = profile2?.isAdmin;

  const onUpdateOnlineUser = async () => {
    try {
      const api = new APIClient();
      const resp = await api.fnGet("/chat-get-active-connection");
      let val = [];
      for (let i = 0; i < resp.length; ++i) {
        val.push(`- ${resp[i].nickName} on ${resp[i].os}.${resp[i].browser}`);
      }

      alert('Found ' + resp.length + ' active connection<br/>' + val.join('<br/>'));
      //console.log(resp);
    } catch (e) {
      alert((e as Error).message);
    }
  }

  const onCheckPushSubscription = async (e: any, puschMe: boolean) => {
    try {
      const token = await Utils.GetFCMToken(true);
      if (!token) {
        alert('No token yet');
        return;
      }
      const parm = { endpoint: token, p256dh: '', auth: '' }
      const api = new APIClient();
      if (puschMe == false) {
        const resp = await api.fnPostForm("/check-push-subscription", parm);
        if (resp.success) {
          alert(resp.data);
        } else {
          alert(resp.message);
        }
        //console.log(resp);
      } else {
        const resp = await api.fnPostForm("/push-me", parm);
        if (resp.success) {
          alert(resp.data);
        } else {
          alert(resp.message);
        }
        //console.log(resp);
      }

    } catch (e) {
      alert((e as Error).message);
    }
  }

  const onReApplyWebUserId = async () => {
    try {
      const msg: string[] = [];
      if (customerIsCdSys == 1) {
        msg.push(`System = DConnect, WebUserID = ${webUserId}`);
      } else if (customerIsCdSys == 2) {
        msg.push(`System = 2S Online, EndUserID = ${webUserId}`);
      } else {
        msg.push(`Unknow System`);
      }
      const api = new ThirdApi();
      api.DConnect_RegisterWebUserId(customerIsCdSys, webUserId, msg);

    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const avatarIcon = () => {
    // const cssFore = profile2.foreColor?.replace("#", "avatar-fore-");
    // const bgColor = profile2.bgColor;
    // const foreColor = profile2.foreColor;
    const profileImage = profile2.pictureUrl ? Utils.FixResourceUrlForNative(profile2.pictureUrl) : '/icons/user-dummy-img.jpg';
    // const abbrName = profile2.abbrName;
    // const cssSize = "avatar-" + (size ? size : "xs");
    return (
      <>
        <img src={profileImage} onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/icons/user-dummy-img.jpg'; }} alt="" className="profile-user rounded-circle"></img>
      </>

    )
  };

  const handleHardRefresh = (event: any) => {
    event.preventDefault();  // Prevent the default link behavior
    window.location.reload();  // Force a hard refresh
  };

  return (
    <Dropdown
      nav
      isOpen={dropdownOpen}
      className="profile-user-dropdown"
      toggle={toggle}
    >
      <DropdownToggle nav className="bg-transparent">
        {/* <img src={avatar1} alt="" className="profile-user rounded-circle" /> */}
        {avatarIcon()}
        {/* <img src={profile2.pictureUrl} alt="" className="profile-user rounded-circle" /> */}
      </DropdownToggle>
      <DropdownMenu>

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          onClick={handleHardRefresh}
        >
          Reload ({Utils.APP_VERSION.replaceAll("?v=", "")}) <i className="bx bx-refresh text-muted ms-1"></i>
        </DropdownItem>

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          onClick={() => onChangeTab(TABS.USERS)}
        >
          Profile <i className="bx bx-user-circle text-muted ms-1"></i>
        </DropdownItem>


        {showIncompletedMenu && (
          <DropdownItem
            className="d-flex align-items-center justify-content-between"
            onClick={() => onChangeTab(TABS.SETTINGS)}
          >
            Setting <i className="bx bx-cog text-muted ms-1"></i>
          </DropdownItem>
        )}

        {/* <DropdownItem
          className="d-flex align-items-center justify-content-between"
          href="/auth-changepassword"
        >
          Change Password <i className="bx bx-lock-open text-muted ms-1"></i>
        </DropdownItem> */}

        {/* <DropdownItem /> */}

        {showIncompletedMenu && (
          <DropdownItem
            className="d-flex align-items-center justify-content-between"
            tag="a"
            href="#"
            onClick={(event) => onCheckPushSubscription(event, false)}
          >
            Check Push Subscribtion <i className="bx bx-log-out-circle text-muted ms-1"></i>
          </DropdownItem>
        )}

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          tag="a"
          href="#"
          onClick={(event) => onCheckPushSubscription(event, true)}
        >
          Push Me <i className="bx bx-log-out-circle text-muted ms-1"></i>
        </DropdownItem>

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          tag="a"
          href="#"
          onClick={onReApplyWebUserId}
        >
          Re-Apply Web/End UserID <i className="fas fa-angle-double-right text-muted ms-1"></i>
        </DropdownItem>

        {showIncompletedMenu && (
          <DropdownItem
            className="d-flex align-items-center justify-content-between"
            tag="a"
            href="#"
            onClick={(event) => onUpdateOnlineUser()}
          >
            Update Online User <i className="bx bx-log-out-circle text-muted ms-1"></i>
          </DropdownItem>
        )}

        <DropdownItem
          className="d-flex align-items-center justify-content-between"
          tag="a"
          // href="/logout"
          onClick={() => {
            dispatch(setActivePostId2(WpModes.Workplace, null, null, null, null, null, "Logout"));
            dispatch(changeSelectedChat(null));
            Utils.LogDb("Logout from SideMenu by click", 1, "SideMenu.tsx", Utils.GetDeviceId());
            navigate('/logoutex?s');
          }}
        >
          Log out <i className="bx bx-log-out-circle text-muted ms-1"></i>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

const SideMenu = ({ onChangeLayoutMode }: any) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const menuItems: MenuItemType[] = MENU_ITEMS;
  // const { activeTab, layoutMode } = useAppSelector(state => ({
  //   activeTab: state.Layout.activeTab,
  //   layoutMode: state.Layout.layoutMode,
  // }));

  const errorData = createSelector(
    (state: any) => state.Layout,
    (state: any) => state.Profile2,
    (state, p2) => ({
      activeTab: state.activeTab,
      layoutMode: state.layoutMode,
      userType: p2.userType,
      userId: p2.userId,
      isAdmin: p2.isAdmin,
      isAllowChat: p2.isAllowChat,
      isAllowChatSup: p2.isAllowChatSup,
    })
  );
  // Inside your component
  const { activeTab, layoutMode, userType, isAdmin, userId, isAllowChat, isAllowChatSup } = useAppSelector(errorData);

  /* 
    tab activation
    */
  const [selectedTab, setSelectedTab] = useState<
    | TABS.BOOKMARK
    | TABS.CALLS
    | TABS.CHAT
    | TABS.CHAT_SUP
    | TABS.CONTACTS
    | TABS.SETTINGS
    | TABS.USERS
    | TABS.TEST
    | TABS.WORKPLACE
    | TABS.TASK
    | TABS.APPROVAL

  >(TABS.CHAT);
  const onChangeTab = (
    id:
      | TABS.BOOKMARK
      | TABS.CALLS
      | TABS.CHAT
      | TABS.CHAT_SUP
      | TABS.CONTACTS
      | TABS.SETTINGS
      | TABS.USERS
      | TABS.TEST
      | TABS.WORKPLACE
      | TABS.TASK
      | TABS.APPROVAL

  ) => {
    // console.log('change tool ' + id);
    setSelectedTab(id);
    localStorage.setItem(SKeys.EmbActiveTab, id);
    dispatch(changeTab(id));
    if (id != activeTab) {// && (id == TABS.CHAT || id == TABS.WORKPLACE)) {
      dispatch(changeSelectedChat(null));
      dispatch(setActivePostId2(WpModes.Workplace, null, null, null, null, null, "Clear when active tab change"));
      //dispatch(setActivePostId2(WpModes.Task, null, null, null, null, null, "Clear when active tab change"));
    }
    if (id == TABS.SETTINGS) {
      dispatch(ucLoadUserConfig());
    }
    if (id != TABS.SETTINGS) {
      dispatch(setActiveTool(null));
    }

  };

  useEffect(() => {
    setSelectedTab(activeTab);
  }, [activeTab]);

  useEffect(() => {
    //if (isAllowChat == false && activeTab == TABS.CHAT) {
    // if (isAllowChat == false && (activeTab == TABS.CHAT || activeTab == TABS.CHAT_SUP)) {
    //   onChangeTab(TABS.WORKPLACE);
    // }
    // 20250915
    if (activeTab == TABS.CHAT && isAllowChat == false) {
      onChangeTab(TABS.WORKPLACE);
    } else if (activeTab == TABS.CHAT_SUP && isAllowChatSup == false) {
      onChangeTab(TABS.WORKPLACE);
    }
  }, [isAllowChat, isAllowChatSup]);

  // console.log('SideMenuUserType:' + userType);
  const showDebugTab = (userType == UserTypes.Employee && isAdmin) || Utils.IsLocalHost();
  const isMenuVisible = (item: MenuItemType) => {
    //if (showDebugTab) return true;

    // if (userType == UserTypes.Employee && item.tabId == TABS.WORKPLACE &&
    //   [1, 7, 15, 19, 21, 24, 29, 34, 42, 50, 64, 77, 10].includes(userId) /*IT person including Sangrung */
    // ) return true;

    // if (userType == UserTypes.Employee && item.tabId == TABS.TASK &&
    //   [1, 7, 15, 19, 21, 24, 29, 34, 42, 50, 64, 77, 78, 4558, 7624].includes(userId) /*IT person including Sangrung */
    // ) return true;


    if (userType == UserTypes.Employee && item.tabId == TABS.WORKPLACE) return true; // open work place menu for employee
    if (userType == UserTypes.Employee && item.tabId == TABS.TASK) return true; // 20251112 allow task for employee
    if (userType == UserTypes.Employee && item.tabId == TABS.APPROVAL) return true;
    if (userType == UserTypes.ExternalUser && (item.tabId == TABS.WORKPLACE || item.tabId == TABS.TASK || item.tabId == TABS.APPROVAL)) return true; // 20251204 open work place for external user

    if (item.tabId == TABS.WORKPLACE) return false;
    if (item.tabId == TABS.TASK) return false; // 20251112 task not show for other
    if (item.tabId == TABS.APPROVAL) return false;
    if (item.tabId == TABS.TEST) return false;

    //if (item.tabId == TABS.CHAT) {
    if (item.tabId == TABS.CHAT) {
      // console.log('isAllowChat:' + isAllowChat);
      return isAllowChat;
    }

    if (item.tabId == TABS.CHAT_SUP) {
      return isAllowChatSup;
    }

    return true;
    //showDebugTab || (item.tabId != TABS.TEST && item.tabId != TABS.WORKPLACE)
    // return true;
  }

  useEffect(() => {
    // activeTab can be left over from a previous user's session (persisted via localStorage) whose
    // permissions don't apply to the currently logged-in user - e.g. user A was on Workplace, logs
    // out, user B (no Workplace permission) logs in - Workplace's icon is hidden but activeTab is
    // still TABS.WORKPLACE, so nothing renders. Fall back to the first visible tab in that case.
    if (!userId) return; // profile not loaded yet
    if (activeTab === TABS.USERS) return; // Profile tab is intentionally not in menuItems (reachable via profile dropdown only)
    const visibleItems = menuItems.filter(isMenuVisible);
    if (visibleItems.length === 0) return;
    if (!visibleItems.some((item) => item.tabId === activeTab)) {
      onChangeTab(visibleItems[0].tabId);
    }
  }, [activeTab, userType, isAllowChat, isAllowChatSup, userId]);

  const visibleThemeMenu = process.env.NODE_ENV === "development" || userId == Const.USER_ID_KITISAK_PRD;


  return (
    <div className={"side-menu flex-md-column " + "side-menu-" + activeTab}>
      {/* LOGO */}
      <Logo />
      {/* end navbar-brand-box */}

      {/* Start side-menu nav */}
      <div className="flex-md-column my-0 sidemenu-navigation">
        <Nav pills className="side-menu-nav" role="tablist">
          {(menuItems || [])
            .filter((item: MenuItemType) => isMenuVisible(item))
            .map((item: MenuItemType, key: number) => (
              <MenuNavItem
                item={item}
                key={key}
                selectedTab={selectedTab}
                onChangeTab={onChangeTab}
              />
            ))}

          {!visibleThemeMenu && (<NavItem className="mt-auto"></NavItem>)}
          {/* change mode */}
          {visibleThemeMenu && (
            <LightDarkMode
              layoutMode={layoutMode}
              onChangeLayoutMode={onChangeLayoutMode}
            />
          )}


          {/* profile menu dropdown */}
          <ProfileDropdownMenu onChangeTab={onChangeTab} />
        </Nav>
      </div>
      {/* end side-menu nav */}
    </div>
  );
};

export default SideMenu;
